import React from 'react';

import { Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';

import { IFinancialStats } from 'interfaces/finance/financeInterfaces';
import { dataCurrentStyle, dataItemStyle, dataStyle, titleStyle } from 'ui/finance/financialStats';

export const formatNumber = (number: string): string =>
  number
    .split('')
    .reverse()
    .join('')
    .replace(/\d\d\d/g, '$& ')
    .split('')
    .reverse()
    .join('');

const FinancialStats: React.FC<IFinancialStats> = ({
  dataFinanceStats,
  isLoadingMainFinanceStats,
  isErrorMainFinanceStats,
}) => (
  <Box
    sx={{
      marginTop: '32px',
    }}
  >
    <Typography variant="h4" sx={titleStyle}>
      Общие финансовые показатели
    </Typography>

    <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
      <Stack>
        <Box component="ul" sx={dataStyle}>
          <Box component="li" sx={() => dataItemStyle()}>
            <Box component="p" sx={() => dataCurrentStyle(1)}>
              {!isLoadingMainFinanceStats && !isErrorMainFinanceStats && dataFinanceStats?.moneyTotal
                ? `${formatNumber(dataFinanceStats?.moneyTotal)} ₽`
                : '0 ₽'}
            </Box>
            <Box component="p" sx={() => dataCurrentStyle(0.6)}>
              Текущие затраты
            </Box>
          </Box>

          <Box component="li" sx={() => dataItemStyle(true)}>
            <Box component="p" sx={() => dataCurrentStyle(1)}>
              {!isLoadingMainFinanceStats && !isErrorMainFinanceStats && dataFinanceStats?.moneyFranchise
                ? `${formatNumber(dataFinanceStats?.moneyFranchise)} ₽`
                : '0 ₽'}
            </Box>
            <Box component="p" sx={() => dataCurrentStyle(0.6)}>
              Остаток мед. бюджета
            </Box>
          </Box>

          <Box component="li" sx={() => dataItemStyle()}>
            <Box component="p" sx={() => dataCurrentStyle(1)}>
              {!isLoadingMainFinanceStats && !isErrorMainFinanceStats && dataFinanceStats?.deposite
                ? `${formatNumber(dataFinanceStats?.deposite)} ₽`
                : '0 ₽'}
            </Box>
            <Box component="p" sx={() => dataCurrentStyle(0.6)}>
              Размер текущего мед. бюджета
            </Box>
          </Box>

          <Box component="li" sx={() => dataItemStyle()}>
            <Box component="p" sx={() => dataCurrentStyle(1)}>
              {!isLoadingMainFinanceStats && !isErrorMainFinanceStats && dataFinanceStats?.budget
                ? `${formatNumber(dataFinanceStats?.budget)} ₽`
                : '0 ₽'}
            </Box>
            <Box component="p" sx={() => dataCurrentStyle(0.6)}>
              Запланированный годовой мед. бюджет
            </Box>
          </Box>
        </Box>
      </Stack>
    </Stack>
  </Box>
);

export { FinancialStats };
